<template>
  <v-container fluid>
    <h1>App Settings Page</h1>
  </v-container>
</template>

<script>
export default {
  name: "Settings",
  route: {
    path: "/settings",
    name: "Settings",
  },
};
</script>

<style></style>
